import { atom } from "jotai"

const defaultMode = { given_name: "Customer", family_name: "", email: "", isAdmin: false }

export const userAtom = atom(defaultMode)
